<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getMenuList)" class="refresh-btn">刷新</el-button>
    <div>
      <el-button type="primary" icon="el-icon-plus" class="mb20" :disabled="menuList.length >= 3" @click="addCatalog">添加目录</el-button>
      <!-- 菜单列表 -->
      <el-table v-loading="loading" :data="menuList" :max-height="tableHeight" :row-key="row => { return row.name }" border :tree-props="{children: 'sub_button'}">
        <el-table-column prop="name" label="菜单名称" min-width="100"/>
        <el-table-column prop="url" label="菜单路径/网址" min-width="200"/>
        <el-table-column label="排序" width="180">
          <template slot-scope="scope">
            <el-button icon="el-icon-top" type="primary" @click="sort(scope.row, -1)" :disabled="scope.row.upFlag">上移</el-button>
            <el-button icon="el-icon-bottom" type="primary" @click="sort(scope.row, 1)" :disabled="scope.row.downFlag">下移</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button icon="el-icon-plus" type="primary" @click="addMenu(scope.row)" :disabled="scope.row.type == 'view' || (scope.row.type != 'view' && scope.row.length > 5)">新增</el-button>
            <el-button icon="el-icon-edit" type="primary" @click="editMenu(scope.row)">修改</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="delMenu(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增和编辑菜单 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="630px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form inline :model="editForm" ref="editForm" label-width="80px" :rules="editFormRules">
          <el-form-item label="菜单名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入菜单名称"/>
          </el-form-item>
          <el-form-item label="菜单类型" prop="type">
            <el-radio-group v-model="editForm.type"> v-show="clickShow"
              <el-radio :label="'click'">目录</el-radio>
              <el-radio :label="'view'">网页</el-radio>
              <el-radio :label="'miniprogram'">小程序</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="appid" prop="appid" v-if="editForm.type == 'miniprogram'">
            <el-input v-model="editForm.appid" resize="none" placeholder="请输入小程序appid"/>
          </el-form-item>
          <el-form-item label="链接地址" prop="url" v-if="editForm.type != undefined && editForm.type != 'click'">
            <el-input type="textarea" v-model="editForm.url" resize="none" :autosize="{minRows: 2, maxRows: 4}" placeholder="请输入菜单路径/网址"/>
          </el-form-item>
          <el-form-item label="组件路径" prop="pagepath" v-if="editForm.type == 'miniprogram'">
            <el-input type="textarea" v-model="editForm.pagepath" resize="none" :autosize="{minRows: 2, maxRows: 4}" placeholder="小程序组件路径"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '修改菜单'" @click="saveEdit">保存修改</el-button>
          <el-button type="success" v-if="dialogTitle == '新增菜单' || dialogTitle == '新增目录'" @click="saveAdd">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script lang="js">
import { menuList1, menuAdd1 } from "@/api/wx_menu";
export default {
  name: 'wechat-menu',
  data() {
    return {
      loading: true,
      menuList: [],
      dialogVisible: false,
      dialogTitle: null,
      editForm: {},
      name: null,
      super_name: null,
      nameList: [],
      flag: true,
      tableHeight: 0, // 表格最大高度
      clickShow: null,
      editFormRules: {
        name: [{required: true, message: "菜单名称不能为空！"}],
        type: [{required: true, message: "跳转类型不能为空！"}],
        appid: [{required: true, message: "小程序appid不能为空！"}],
        pagepath: [{required: true, message: "小程序路径不能为空不能为空！"}],
        url: [{required: true, message: "链接地址不能为空！"}],
      },
      searchForm: {}
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 230;
    this.getMenuList();
  },
  methods: {
    // 获取菜单列表
    async getMenuList() {
      let { code, msg } = await menuList1();
      if (code == 200) {
        this.loading = false;
        if (JSON.parse(msg).menu && JSON.parse(msg).menu.button) this.menuList = JSON.parse(msg).menu.button;
        let _this = this;
        this.menuList.forEach((item, i) => {
          if (!item.type) item.type = 'click';
          item.types = 'menu';
          item.index = i;
          if (i == 0) item.upFlag = true;
          else item.upFlag = false;
          if ((i + 1) == _this.menuList.length) item.downFlag = true;
          else item.downFlag = false;
          if (item.sub_button && item.sub_button.length > 0) {
            item.sub_button.forEach((items, j) => {
              items.types = 'sub_menu';
              items.index = j;
              if (j == 0) items.upFlag = true;
              else items.upFlag = false;
              if ((j + 1) == item.sub_button.length) items.downFlag = true;
              else items.downFlag = false;
            })
          }
        });
      }
    },
    // 排序
    sort(obj, sort) {
      let insertObj = JSON.parse(JSON.stringify(obj));
      if (obj.types == 'menu') {
        this.menuList[obj.index] = this.menuList[obj.index + sort];
        this.menuList[obj.index + sort] = insertObj;
        this.upload('排序成功！', true);
      }
    },
    // 新增目录
    addCatalog() {
      this.editForm = { name: null, type: 'click', key: 'newCatalog', sub_button: []};
      this.super_name = '主菜单';
      this.dialogVisible = true;
      this.dialogTitle = "新增目录";
      this.clickShow = true;
    },
    // 新增二级菜单
    addMenu(row) {
      this.clickShow = false;
      this.editForm = { name: null, url: null, type: "view", index: null, pagepath: null, appid: null };
      this.super_name = row.name;
      this.dialogVisible = true;
      this.dialogTitle = "新增菜单";
    },
    // 判断菜单名称是否重复
    judge() {
      this.nameList = [], this.flag = true;
      this.menuList.forEach((item, i) => {
        this.nameList.push({name: item.name, index: i});
        item.sub_button.forEach((items, j) => { this.nameList.push({name: items.name, index: j + 3}) });
      });
      this.nameList.forEach(item => {
        if (this.editForm.name == item.name && this.editForm.index != item.index) this.flag = false;
      });
      if (this.flag == false) this.$message.error("该菜单名称已存在, 请修改后再试！");
    },
    // 保存新增
    saveAdd() {
      this.judge();
      if (this.flag == true) {
        if (this.super_name == '主菜单') this.menuList.push(this.editForm);
        else this.menuList.forEach(item => { if (this.super_name == item.name) item.sub_button.push(this.editForm) });
        this.upload(`${this.dialogTitle}成功成功！`);
      }
    },
    // 修改菜单
    editMenu(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.name = row.name;
      this.menuList.forEach((item, i) => {
        if (row.name == item.name) this.editForm.index = i;
        else item.sub_button.forEach((items, j) => { if (row.name == items.name) this.editForm.index = j + 3 });
      });
      this.dialogVisible = true;
      this.dialogTitle = "修改菜单";
    },
    // 保存修改
    saveEdit() {
      this.judge();
      function assignment(obj, form, flag) {
        obj.name = form.name;
        obj.url = form.url;
        obj.pagepath = form.pagepath;
        obj.appid = form.appid;
        obj.type = form.type;
        if (flag && form.type == 'click') obj.key = 'editCatalog';
      }
      if (this.flag == true) {
        this.menuList.forEach(item => {
          if (this.name == item.name) assignment(item, this.editForm, true);
          else item.sub_button.forEach(items => { 
            if (this.name == items.name) assignment(items, this.editForm);
          })
        });
        this.upload("修改菜单成功！");
      }
    },
    // 删除菜单
    delMenu(row) {
      this.$confirm('确认删除该菜单？')
      .then(_ => {
        let index, super_index, flag;
        this.menuList.forEach((item, i) => {
          if (item.name == row.name) {
            index = i;
            super_index = '-1';
          } else item.sub_button.forEach((items, j) => {
            if (items.name == row.name) {
              if (item.sub_button.length > 1) {
                index = j;
                super_index = i;
              }
              else return flag = false;
            }
          })
        });
        if (flag == false) this.$message.error("最后一个子菜单，不能删除！");
        else {
          if (super_index == '-1') this.menuList.splice(index, 1);
          else this.menuList[super_index].sub_button.splice(index, 1);
          this.upload("删除菜单成功！", true);
        }
      })
      .catch(_ => {});
    },
    // 上传菜单
    upload(msg, flag) {
      let _this = this;
      function func() {
        menuAdd1({ button: _this.menuList }).then(res => {
          if (res.code == 200) _this.$message.success(msg);
          _this.dialogVisible = false;
          _this.$refresh(_this.getMenuList);
        })
      }
      if (flag) func();
      else {
        this.$refs['editForm'].validate((valid) => {
          if (valid) func();
          else return false;
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.el-input, .el-textarea {
  width: 500px;
}
</style>